import React from "react";
import { Col, Space } from "antd";

import EventUserList from "../../components/EventUserList";
import EventPrizeList from "../../components/EventPrizeList";

function CampingCarShow() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">2023 오토살롱위크</h3>
                <EventUserList eventId={3} />
                <EventPrizeList eventId={3} />
            </Space>
        </div>
    );
}

export default CampingCarShow;
